import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TagAutocomplete } from "@/components/TagAutocomplete";

interface Props {
  initialQuery?: string;
  onSearch?: (query: string) => void;
  autoFocus?: boolean;
}

export function SearchBar({ initialQuery = "", onSearch, autoFocus = false }: Props) {
  const [value, setValue] = useState(initialQuery);
  const navigate = useNavigate();

  useEffect(() => {
    setValue(initialQuery);
  }, [initialQuery]);

  function submit() {
    const query = value.trim();
    if (onSearch) onSearch(query);
    else navigate(`/search?q=${encodeURIComponent(query)}`);
  }

  return (
    <div className="flex gap-2 w-full">
      <TagAutocomplete
        value={value}
        onChange={setValue}
        onCommit={submit}
        placeholder="Search tags… (e.g. canine animated -cat ~wolf ~fox, or artist:foo)"
        autoFocus={autoFocus}
        className="flex-1"
        inputClassName="w-full bg-surface-1 border border-surface-3 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-accent transition-colors placeholder-zinc-600"
      />
      <button
        onClick={submit}
        className="bg-accent hover:bg-accent-hover text-white font-semibold px-5 py-3 rounded-lg transition-colors text-sm"
      >
        Search
      </button>
    </div>
  );
}
